import * as React from 'react';
import LoadableVisibility from 'react-loadable-visibility/react-loadable';
import Loading from '../../library/loaders';

const LoadableComponent = LoadableVisibility({
  loader: () => import('./index'),
  loading: Loading,
  delay: 2000
});

export default class Container extends React.Component {
  render() {
    return <LoadableComponent {...this.props} />;
  }
}
